import SearchDetailRow from "../SearchDetailRow";
import GenericDropdownCard from "../GenericDropdownCard";
import {useEffect, useState} from "react";


const PropertyDetails = (props) => {
    // Report Types
    const FINVISE = 1
    const RICS = 2
    const selectedType = props.selectedType;

    const category = props.category
    const setShowPropertyDetails = props.setShowPropertyDetails

    const bedrooms = props.bedrooms
    const setBedrooms = props.setBedrooms
    const bathrooms = props.bathrooms
    const setBathrooms = props.setBathrooms
    const livingRooms = props.livingRooms
    const setLivingRooms = props.setLivingRooms
    const size = props.size
    const setSize = props.setSize
    const reference = props.reference
    const setReference = props.setReference
    const estValue = props.estValue
    const setEstValue = props.setEstValue
    const [formattedValue, setFormattedValue] = useState("")

    const uprn = props.uprn
    const setUprn = props.setUprn
    const yearBuilt = props.yearBuilt
    const setYearBuilt = props.setYearBuilt
    const propertyType = props.propertyType
    const setPropertyType = props.setPropertyType
    const propertyTypes = props.propertyTypes


    const propertySummary = props.propertySummary
    const setPropertySummary = props.setPropertySummary

    const formatSize = (_string) => {
        return _string && _string.replace(/\D/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    useEffect(() => {
        if (!estValue) {
            setFormattedValue("")
        } else {
            let t = new Intl.NumberFormat().format(estValue)
            setFormattedValue(t)
        }
    }, [estValue]);

    return (
        <>
            {selectedType && selectedType.id === RICS ?
                <>
                    {category && category.id === 1 ?
                        <>
                            <div className="valuation-type-dropdown-options">
                                <div className="valuation-type-option-container counter first aligned">
                                    <div className="valuation-type-option counter relative last">
                                        <div className="valuation-type-option-title">Est. Value</div>
                                        <input type="text" value={formattedValue} id="est-value-input" inputMode="numeric"
                                               onChange={(ev) => {
                                                   const digits = ev.target.value.replace(/\D/g, "")
                                                   setEstValue(digits)
                                               }}/>
                                        <div className="valuation-type-option-pound-symbol">£</div>
                                    </div>
                                </div>
                                <div className="valuation-type-option-container counter aligned">
                                    <div className="valuation-type-option counter last">
                                        <div className="valuation-type-option-title">Reference</div>
                                        <input type="text" value={reference}
                                               onChange={(ev) => setReference(ev.target.value)}/>
                                    </div>
                                </div>
                                <SearchDetailRow value={bedrooms} change={setBedrooms} first={true} name={"Bedrooms"}
                                                 max={5}/>
                                <SearchDetailRow value={bathrooms} change={setBathrooms} name={"Bathrooms"}/>
                                <SearchDetailRow value={livingRooms} change={setLivingRooms} name={"Living rooms"}/>
                                <div className="valuation-type-option-container counter last">
                                    <div className="valuation-type-option counter last">
                                        <div className="valuation-type-option-title">Sq ft</div>
                                        <input type="text" value={formatSize(size)}
                                               onChange={(ev) => setSize(ev.target.value)}/>
                                    </div>
                                </div>
                            </div>
                            <div className="invisible-page-overlay" onClick={() => setShowPropertyDetails(false)}/>
                        </>
                        : category && category.id === 2 ?
                            <>
                                <div className="valuation-know-property-free-text-container">
                                    <div className="valuation-type-option full last">
                                        Share summary details of the property:
                                    </div>
                                    <textarea className="valuation-know-property-free-text" value={propertySummary}
                                              onChange={(ev) => {
                                                  if (ev.target.value.length > 1100) return
                                                  setPropertySummary(ev.target.value)
                                              }}/>
                                    <div className="valuation-know-property-free-text-character-count">
                                        {propertySummary.length}/1100 characters
                                    </div>
                                </div>
                                <div className="invisible-page-overlay" onClick={() => {
                                    setShowPropertyDetails(false)
                                }}/>
                            </>
                            : null
                    }
                </>
                :
                (selectedType && selectedType.id === FINVISE ?
                    <>
                        <div className="valuation-type-dropdown-options finvise">
                            <SearchDetailRow value={bedrooms} change={setBedrooms} first={true} name={"Bedrooms"} max={5}/>
                            <div className="valuation-type-option-container counter aligned">
                                <div className="valuation-type-option small counter last">
                                    <div className="valuation-type-option-title">Year built</div>
                                    <input type="text" value={yearBuilt}
                                           onChange={(ev) => setYearBuilt(ev.target.value)}/>
                                </div>
                            </div>
                            <div className="valuation-type-option-container counter aligned">
                                <GenericDropdownCard title={""} default="Property type" value={propertyType}
                                                     options={propertyTypes} setValue={setPropertyType} />
                            </div>
                            <div className="valuation-type-option-container counter aligned last">
                                <div className="valuation-type-option small counter last">
                                    <div className="valuation-type-option-title">UPRN</div>
                                    <input type="text" value={uprn}
                                           onChange={(ev) => setUprn(ev.target.value)}/>
                                </div>
                            </div>
                        </div>
                        <div className="invisible-page-overlay" onClick={() => setShowPropertyDetails(false)}/>

                    </>
                    :
                    null
                )
            }
        </>
    )
}

export default PropertyDetails;
